module.exports = __webpack_public_path__ + "img/recipients.7cc6df81.png";